
import { mixins } from "vue-class-component";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PaginationCenter extends mixins() {
  @Prop(Number) readonly resultFrom!: number;
  @Prop(Number) readonly resultTo!: number;
  @Prop(Number) readonly total!: number;
}
